module.exports = __webpack_public_path__ + "static/media/mini-terminal.f5a8e1d0.svg";